export default "<ng-container *ngIf=\"!hoursView\">\n  <div class=\"inner\"></div>\n  <div class=\"date-name\">{{ getDay(date) }}</div>\n</ng-container>\n"